package io.horion.auth.di

import io.horion.auth.api.repository.AuthRepository
import io.horion.auth.api.services.AuthService
import io.horion.auth.api.repository.AuthRepositoryImpl
import io.horion.auth.api.repository.ProfileRepository
import io.horion.auth.api.repository.ProfileRepositoryImpl
import io.horion.auth.api.services.ProfileService
import org.koin.dsl.module

val repositoryModule = module {
    // Services API
    single { AuthService() }
    single { ProfileService() }

    // Repositories
    single<AuthRepository> {
        AuthRepositoryImpl(authService = get())
    }

    single<ProfileRepository> {
        ProfileRepositoryImpl(profileService = get())
    }
}
